export const landingSectionCardData = [
    {
        title: "REAL-WORLD ASSETS",
        data: "Credix provides credit to FinTechs lenders in Latin America. All deals on Credix are overcollateralized by real-world assets like loans, receivables, cars...",
        link: "https://docs.credix.finance/other-links-and-resources/faq#what-are-the-kind-of-fintechs-that-are-being-financed-by-credix",
    },
    {
        title: "DIVERSIFIED RISK",
        data: "Invest in our liquidity pool to diversify your exposure to all deals. In addition, your investment is protected by first-loss capital from institutional investors.",
        link: "https://docs.credix.finance/other-links-and-resources/faq#whats-the-risk-how-is-my-investment-protected-from-defaults",
    },
]